// 用户列表
export default {
    heard_title: "用户列表",
    heard_btn: "用户注册",
    fl_mobile: "手机号码",
    fl_nickName: "昵称:",
    fl_status: "状态:",
    fl_startTime: "注册时间:",
    fp_mobile: "请输入手机号码",
    fp_nickName: "请输入昵称",
    fp_status: "请选择账户状态",
    fp_startTime: "请选择开始日期",
    fp_endTime: "请选择结束日期",
    op_all: "全部",
    op_approved: "正常",
    op_frozen: "关闭",
    tl_account: "用户账户",
    tl_nickName: "用户昵称",
    tl_level: "级别",
    tl_experience: "经验值",
    tl_balance: "可用余额",
    tl_consumeAount: "消费金额",
    tl_orderQuantity: "订单数量",
    tl_status: "状态",
    btn_recharge: "充值",
    btn_view: "查看",
    pay_number: "支付金额",
    pay_unit: "元",
    pay_way: " 支付方式",
    dt_recharge: "充值",
    dl_amount: "充值金额:",
    dl_payModel: "支付方式:",
    dialog_label3: "付款码:",
    dl_authCode: "付款码:",
    dl_earnedRates: "实收",
    dl_change: "找零",
    dl_rewoadAmount: "充值活动:",
    dl_discount: "会员卡充值:",
    dp_amount: "请输入充值金额",
    dp_payModel: "请选择支付方式",
    dp_authCode: "请使用扫码枪扫描付款码",
    dp_rewoadAmount: "请选择",
    dp_discount: "请选择",
    vx_pay: "微信付款",
    cash_pay: "现金",
    pos_pay: "刷卡",
    other_pay: "其他",
    ali_pay: "支付宝",
    dt_register: "注册",
    dt_nickName: "昵称",
    dt_mobile: "手机号",
    dt_gender: "性别",
    dt_age: "生日",
    radio_male: "男",
    radio_famale: "女",
    em_mobile: "请输入手机号",
    em_mobileFomat: "请输入正确的手机号",
    em_nickName: "请输入昵称",
    sm_register: "注册成功",
    em_register: "注册失败",
    pay_tip1: "支付成功",
    pay_tip2: "支付失败",
    pay_tip3: "支付结果未知",
    pay_step1: "确定",
    pay_step2: "重新支付",
    ft_wechatpay: "微信支付",
    ft_alipay: "支付宝",
    ft_wallet: "会员卡",
    ft_cash: "现金",
    ft_pos: "刷卡",
    ft_other: "其他"
};
